<template>
  <div class="page">
    <div class="page__title">
     {{ getModuleConfig("records_page.form_title") }}
    </div>
    <div
      class="page__desc"
      v-html="getModuleConfig('records_page.form_desc')"
    ></div>
    <div  class="page__content" v-if="getModuleConfig('records_page.content')" v-html="getModuleConfig('apply_page.content')"></div>
    <coupon-filters
      v-if="showFilter"
      class="s-mb-3"
      :options="filterOptions"
      v-model="filter"
    ></coupon-filters>
    <div>
      <Loading v-if="showLoading" loading-message="載入中..." />
      <div v-else-if="!showLoading && currentData.coupons.length > 0">
        <coupon-card
          v-for="(item, index) in currentData.coupons"
          :key="index"
          :coupon="item"
          :buttonText="item.status == 'applied_and_not_yet' ? '尚未開始' : '查看'"
          :showCode="codeIsVisibleInList && couponModels[index]?.isInRedeemableTimeRange()"
          @exchange="showCouponModal"
        >
        </coupon-card>
        <Pagination
          v-model="page"
          :total-page="currentData.meta.lastPage"
          :has-next="currentData.meta.hasNext"
          @input="handlePageIsChanged"
          style="margin: 32px auto 50px"
        />
      </div>
      <coupon-empty v-else />
    </div>
    <coupon-modal
      ref="couponModal"
      :coupon="selectedCoupon"
      @confirmed="refresh"
      :showCode="codeIsVisibleInDetail"
      :showQrcodeButton="showQrcodeButton"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import CouponCard from "@/pages/Dashboard/Coupon/CouponCard.vue";
import CouponModal from "@/components/Page/Liff/CouponList/CouponModal.vue"
import CouponEmpty from "@/pages/Dashboard/Coupon/CouponEmpty.vue";
import CouponFilters from "@/pages/Dashboard/Coupon/CouponFilters.vue";
import couponApi from '@/apis/liff/v2/coupon'
import Loading from "@/components/Page/Liff/Shared/Loading";
import Pagination from '@/components/Page/Liff/Shared/PaginationWithoutRedirect'
import Coupon from "@/models/Coupon.model"
import { pushQuery } from "@/utils/UrlMutater";

export default {
  components: { CouponCard, CouponEmpty, CouponFilters, Loading, CouponModal, Pagination },
  inject: ['layoutInstance'],
  data() {
    return {
      showLoading: true,
      filter: "all",
      page: +this.$route.query.page || 1,
      provider: null,
      selectedCoupon: {},
      couponData: {
        all: { coupons: [], meta: { total: 0, lastPage: 1 } },
        used: { coupons: [], meta: { total: 0, lastPage: 1 } },
        expired: { coupons: [], meta: { total: 0, lastPage: 1 } },
      },
    };
  },
  computed: {
    ...mapGetters({ getModuleConfig: 'liffModule/getConfig' }),
    showFilter() {
      return this.provider == "waltily"
    },
    filterOptions() {
      return [
        { key: "all", text: `全部 (${this.couponData.all.meta.total})` },
        { key: "used", text: `已使用 (${this.couponData.used.meta.total})` },
        { key: "expired", text: `已過期 (${this.couponData.expired.meta.total})` },
      ];
    },
    currentData() {
      return this.couponData[this.filter] || { coupons: [], meta: { total: 0, lastPage: 1 } };
    },
    couponModels() {
      return this.currentData.coupons.map(coupon => new Coupon(coupon))
    },
    codeIsVisibleInList() {
      return this.getModuleConfig('liff_coupon', 'records.list.redeem_code.enable') ?? true
    },
    codeIsVisibleInDetail() {
      return this.getModuleConfig('liff_coupon', 'records.detail.redeem_code.enable') ?? true
    },
    showQrcodeButton() {
      return this.getModuleConfig('liff_coupon', 'records.detail.qrcode.enable') ?? false
    },
  },
  watch: {
    filter(newVal) {
      this.page = 1;
      this.fetchCouponsByStatus(newVal, 1);
    },
    'layoutInstance.providerParams': {
      handler(newVal) {
        this.onProviderChanged(newVal);
      },
      deep: true
    }
  },
  mounted() {
    this.fetchAllFirstThenOthersIfWaltily();
  },
  methods: {
    async fetchAllFirstThenOthersIfWaltily() {
      this.showLoading = true;
      await this.fetchCouponsByStatus("all", 1);
      if (this.provider === "waltily") {
        await Promise.all([
          this.fetchCouponsByStatus("used", 1),
          this.fetchCouponsByStatus("expired", 1),
        ]);
      }
      this.showLoading = false;
    },
    async fetchCouponsByStatus(type, page = 1) {
      this.page = page
      pushQuery({ page })
      let status;
      if (type === "all") status = "record";
      else if (type === "used") status = "redeemed";
      else if (type === "expired") status = "expired";
      try {
        const apiParams = {
          page,
          status,
          ...this.layoutInstance.providerParams,
        };
        const res = await couponApi.getCouponLists(apiParams);
        this.couponData[type] = {
          coupons: res.data || [],
          meta: {
            total: res.total || 0,
            lastPage: res.lastPage || 1,
            hasNext: res.hasNext,
          }
        };
        if (type === "all") this.provider = res.provider;
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.$swal.fire({
            type: "error",
            title: "錯誤",
            text: error.response.data.message
          });
        }
        this.couponData[type] = {
          coupons: [],
          meta: {
            total: 0,
            lastPage: 1,
          }
        }
      }
    },
    showCouponModal(coupon) {
      this.selectedCoupon = coupon
      this.$refs.couponModal.open()
    },
    refresh() {
      this.selectedCoupon = {}
      this.fetchCouponsByStatus(this.filter, this.page)
    },
    onProviderChanged(params) {
      this.provider = params.provider
      this.fetchAllFirstThenOthersIfWaltily()
    },
    handlePageIsChanged(page) {
      this.fetchCouponsByStatus(this.filter, page)
    },
  },
};
</script>

<style></style>
